import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { ChevronIconStyled } from './TrlChevronArrow.styles';

export const TrlChevronArrow = ({ ...props }) => (
  <ChevronIconStyled icon={faChevronDown} {...props} />
);
